import script from "./SidebarComponent.vue?vue&type=script&lang=ts&setup=true"
export * from "./SidebarComponent.vue?vue&type=script&lang=ts&setup=true"

import "./SidebarComponent.vue?vue&type=style&index=0&id=23b2062c&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/WEAS/WEAS_CI/WEAS_FRONT/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-23b2062c"]])

export default __exports__